import { useMemo } from 'react';
import useSWR, { mutate } from 'swr';

import { fetcher, endpoints } from 'src/utils/axios';

export function useGetReciepts(params) {
  const URL = [endpoints.receipts.all, { params }];

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);
  const memoizedValue = useMemo(
    () => ({
      receiptsData: data?.receiptsData || [],
      unitServices: data?.unitServices || [],
      patients: data?.patients || [],
      stakeholders: data?.stakeholders || [],
      lengths: data?.lengths || {},
      totals: data?.totals || {},
      loading: isLoading,
      error,
      validating: isValidating,
      empty: !isLoading && !data?.length,
    }),
    [data, error, isLoading, isValidating]
  );
  const refetch = async () => {
    // Use the mutate function to re-fetch the data for the specified key (URL)
    await mutate(URL);
  };

  return { ...memoizedValue, refetch };
}
